import EventTable from "components/eventTable";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEventDetails, fetchEventDetailsBeforeLogin, fetchFancy, fetchSportsEvents, setSortedEvents } from "../../redux/slice/events/eventsSlice";
import { useNavigate, useParams } from "react-router-dom";
import Fancy from "components/fancy";
import BetsSlip from "components/betsSlip";
// import { WebSocketContext } from "context/websocket";
import { NotificationManager } from "react-notifications";
import Appconfig from '../../config/config'
import axios from "axios";
import { getUserBalanceAsync } from '../../redux/slice/user/userSlice'
import { setProfileData } from "../../redux/slice/auth/authSlice";
import { fetchUserProfile } from "services/users";
import { Modal, Switch } from "antd";
import { fetchOpenBetById } from "../../redux/slice/openBets/openBetsSlice"
import { getFancyExposure } from "../../redux/slice/fancyExposure/fancyExposureSlice";
import Loader from "components/loader";
import { blockUnblockMarketTypeAsync, fetchBlockedMarketTypesAsync } from "../../redux/slice/blockMarkets/blockMarkets";

import { useWebSocket } from "context/WebSocketProvider";
import WebSocketEventEmitter from "context/eventEmitter";
import { getMatchFancyData } from "../../redux/slice/fancyData/fancyDataSlice";
import { fetchchipsAsync } from "../../redux/slice/chips/chipsSlice";

function Event() {

    const { sendMessage, marketDataMsg, socketStatus } = useWebSocket();

    useEffect(() => {
        if (socketStatus) {
            sendMessage(
                {
                    "action": "JOIN",
                    "data": {
                        "username": "suthard444",
                        "event_id": event_id
                    }
                })
        }
    }, [socketStatus])

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { event_id } = useParams();
    const { event_type_id } = useParams();
    const [loadingForBetPlace, setLoadingForBetPlace] = useState(false)
    const { chips, isDefaultChip } = useSelector((state) => state.chips);
    const { sortedMarketTypes, eventData, fancy, loading, error } = useSelector((state) => state.events);
    const { marketTypes } = useSelector((state) => state.blockMarkets);
    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const { openBets, loading: openBetsLoading, error: openBetsError } = useSelector((state) => state.openBets);
    const { data: fancyExposure, loading: fancyExposureLoading, error: fancyExposureError } = useSelector((state) => state.fancyExposure);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const [showBetsSlip, setShowBetsSlip] = useState(false)
    const [isReady, setIsReady] = useState(false);
    // const websocket = useContext(WebSocketContext);
    const [type, setType] = useState('back')
    const [selection_id, setSelection_id] = useState('')
    const [marketId, setMarketId] = useState('')
    const [selectionIdNew, setSelectionIdNew] = useState('')
    const [is_fancy, setIs_fancy] = useState(false)
    const [fancyOddsData, setFancyOddsData] = useState(fancy);
    const match_odds_bet_limit = 20;
    const [htmlId, setHtmlId] = useState('')
    const [size, setSize] = useState('')
    const [ProfitValue, setProfitValue] = useState(0);
    const [StakeValue, setStakeValue] = useState(0);
    const [defaultStake, setDefaultStake] = useState(0)
    const [lossValue, setLossValue] = useState(0);
    const [isBetPlaced, setIsBetPlaced] = useState(false);
    const { userBalance } = useSelector((state) => state.userbal);
    const token = localStorage.getItem('token');
    const [activeTab, setActiveTab] = useState('Market')
    const [bookModalOpen, setBookModalOpen] = useState(false)
    const [postionFancyList, setPostionFancyList] = useState([])
    const [BetPlaceData, setBetPlaceData] = useState({
        event_id: "",
        market_id: "",
        is_back: "",
        price: "",
        is_fancy: "",
        selection_id: "",
        runner_name: "",
        PM_FANCY: false
    });
    const [showTv, setShowTv] = useState(false);
    const [marketName, setMarketName] = useState('');

    const handleSwitchChange = (checked) => {
        setShowTv(checked);
    };
    const checkHighestMarketPrice = (runner, market_name) => {
        let price_exceed_by_limit = false;
        // await Promise.all(
        if (runner.market_id.toString().includes('BM')) {

            if (runner.back_1_price > 0) {
                if (parseFloat((runner.back_1_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }

            if (runner.lay_1_price > 0) {
                if (parseFloat((runner.lay_1_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }



            if (runner.back_1_price <= 0) {
                price_exceed_by_limit = true;
            }


            if (runner.lay_1_price <= 0) {
            }




        }
        else if (market_name == 'Bookmaker') {

            if (runner.back_1_price > 0) {
                if (parseFloat((runner.back_1_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }

            if (runner.lay_1_price > 0) {
                if (parseFloat((runner.lay_1_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }


            if (runner.back_1_price <= 0) {
                price_exceed_by_limit = true;
            }


            if (runner.lay_1_price <= 0) {
            }


        }
        else {
            if (parseFloat(runner.back_1_price) > match_odds_bet_limit || parseFloat(runner.lay_1_price) > match_odds_bet_limit) {
                price_exceed_by_limit = true;
            }


            if (parseFloat(runner.back_1_price) <= 0 && parseFloat(runner.lay_1_price) <= 0) {
                price_exceed_by_limit = true;
            }
        }


        if (runner.market_id.toString().includes('BM')) {

            if (runner.back_2_price > 0) {
                if (parseFloat((runner.back_2_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }

            if (runner.lay_2_price > 0) {
                if (parseFloat((runner.lay_2_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }


            if (runner.back_2_price <= 0) {
                price_exceed_by_limit = true;
            }


            if (runner.lay_2_price <= 0) {
            }

        }
        else if (market_name == 'Bookmaker') {

            if (runner.back_2_price > 0) {
                if (parseFloat((runner.back_2_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }

            if (runner.lay_2_price > 0) {
                if (parseFloat((runner.lay_2_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }

            if (runner.back_2_price <= 0) {
                price_exceed_by_limit = true;
            }


            if (runner.lay_2_price <= 0) {
            }

        }
        else {
            if (parseFloat(runner.back_2_price) > match_odds_bet_limit || parseFloat(runner.lay_2_price) > match_odds_bet_limit) {
                price_exceed_by_limit = true;
            }


            if (parseFloat(runner.back_2_price) <= 0 && parseFloat(runner.lay_2_price) <= 0) {
                price_exceed_by_limit = true;
            }
        }


        // 3
        if (runner.market_id.toString().includes('BM')) {

            if (runner.back_3_price > 0) {
                if (parseFloat((runner.back_3_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }

            if (runner.lay_3_price > 0) {
                if (parseFloat((runner.lay_3_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }

            if (runner.back_3_price <= 0) {
                price_exceed_by_limit = true;
            }


            if (runner.lay_3_price <= 0) {
            }



        }
        else if (market_name == 'Bookmaker') {

            if (runner.back_3_price > 0) {
                if (parseFloat((runner.back_3_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }

            if (runner.lay_3_price > 0) {
                if (parseFloat((runner.lay_3_price / 100) + 1) > match_odds_bet_limit) {
                    price_exceed_by_limit = true;
                }

            }


            if (runner.back_3_price <= 0) {
                price_exceed_by_limit = true;
            }


            if (runner.lay_3_price <= 0) {
            }



        }
        else {
            if (parseFloat(runner.back_3_price) > match_odds_bet_limit || parseFloat(runner.lay_3_price) > match_odds_bet_limit) {
                price_exceed_by_limit = true;
            }


            if (parseFloat(runner.back_3_price) <= 0 && parseFloat(runner.lay_3_price) <= 0) {
                price_exceed_by_limit = true;
            }
        }

        // )


        return price_exceed_by_limit;
    }
    async function fancyHtml(fancys) {
        var superiors = ["270", "259", "185", "177", "30"];
        var matchId = event_id;
        if (matchId) {
            if (fancys) {
                let check_new_fields_added = false;

                const result = fancys.find(item => {
                    console.log(`Checking item with selection_id: ${item.selection_id}, game_status: ${item.game_status}, selectionIdNew: ${String(selectionIdNew)}`);

                    const gameStatusMatch = item.game_status === "SUSPENDED" || item.game_status === "Ball Running";
                    const selectionIdMatch = String(item.selection_id) === String(selectionIdNew);

                    console.log(`gameStatusMatch: ${gameStatusMatch}, selectionIdMatch: ${selectionIdMatch}`);

                    return gameStatusMatch && selectionIdMatch;
                });

                // const result = fancys.find(item => item.game_status === "" && item.selection_id === selection_id);
                if (result) {
                    setIs_fancy(false);
                }

                setFancyOddsData(fancys)

            }
        }
    }
    useEffect(() => {
        if (event_id && isAuthenticated) {

            dispatch(fetchEventDetails(event_id));
            dispatch(fetchOpenBetById(event_id));
            dispatch(fetchFancy(event_id));
        }
        else if (event_id && !isAuthenticated) {
            dispatch(fetchEventDetailsBeforeLogin(event_id));
            dispatch(fetchFancy(event_id));
        }
    }, [event_id, dispatch, isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchchipsAsync());
        }
    }, [dispatch, isAuthenticated]);

    // useEffect(() => {
    //     if (websocket) {
    //         websocket.onopen = () => {
    //             console.log('Websocket is open ', new Date());
    //             setIsReady(true)
    //         };

    //         if (websocket.readyState) {
    //             console.log('WESOCKET JOIN REQUEST SENT', {
    //                 "action": "JOIN",
    //                 "data": {
    //                     "username": "suthard444",
    //                     "event_id": event_id
    //                 }
    //             });

    //             websocket.send(JSON.stringify(
    //                 {
    //                     "action": "JOIN",
    //                     "data": {
    //                         "username": "suthard444",
    //                         "event_id": event_id
    //                     }
    //                 }))
    //         }
    //     }
    // }, [websocket, event_id, isReady]);

    useEffect(() => {
        const handleMessage = (data) => {
            if (data.action == "MARKET_UPDATE") {
                let market = data.data;
                if (market) {
                    if (market.market_types.length > 0) {
                        market.market_types.map((market_type, index) => {
                            market_type.hasOwnProperty("runners") && market_type.runners.map((runner, index) => {
                                // if (market_type.status == 'OPEN') {
                                // } else {
                                // }


                                // if (runner.market_id == '4.1680554980-BM') {
                                // }
                                if (market_type.market_name == 'Bookmaker' || market_type.market_name == "Bookmaker 2") {

                                    if (runner?.back_1_price > 100) {
                                        runner.status = 'SUSPENDED';
                                    }
                                }

                                if (checkHighestMarketPrice(runner, market_type.market_name)) {
                                    if (runner.status == 'SUSPENDED' || market_type.status == "CLOSED") {
                                        const selecid = runner.selection_id
                                        const suspendedDiv = document.querySelector(`.suspended_${runner.market_id.replace('.', '')}_${selecid}`);
                                        const suspendedMDiv = document.querySelector(`.Msuspended_${runner.market_id.replace('.', '')}_${selecid}`);
                                        const suspendedMSOCCERDiv = document.querySelector(`.m-soccer-suspended_${runner.market_id.replace('.', '')}_${selecid}`);
                                        const suspendedSOCCERDiv = document.querySelector(`.soccer-suspended_${runner.market_id.replace('.', '')}_${selecid}`);
                                        if (suspendedDiv) {
                                            suspendedDiv && suspendedDiv.classList.remove('hidden');
                                        }
                                        if (suspendedMDiv) {
                                            suspendedMDiv && suspendedMDiv.classList.remove('hidden');
                                        }
                                        if (suspendedMSOCCERDiv) {
                                            suspendedMSOCCERDiv && suspendedMSOCCERDiv.classList.remove('hidden');
                                        }
                                        if (suspendedSOCCERDiv) {
                                            suspendedSOCCERDiv && suspendedSOCCERDiv.classList.remove('hidden');
                                        }
                                    }
                                    else {
                                        const selecid = runner.selection_id
                                        const suspendedDiv = document.querySelector(`.suspended_${runner.market_id.replace('.', '')}_${selecid}`);
                                        const suspendedMDiv = document.querySelector(`.Msuspended_${runner.market_id.replace('.', '')}_${selecid}`);
                                        const suspendedMSOCCERDiv = document.querySelector(`.m-soccer-suspended_${runner.market_id.replace('.', '')}_${selecid}`);
                                        const suspendedSOCCERDiv = document.querySelector(`.soccer-suspended_${runner.market_id.replace('.', '')}_${selecid}`);
                                        if (suspendedDiv) {
                                            suspendedDiv && suspendedDiv.classList.add('hidden');
                                        }
                                        if (suspendedMDiv) {
                                            suspendedMDiv && suspendedMDiv.classList.add('hidden');
                                        }
                                        if (suspendedMSOCCERDiv) {
                                            suspendedMSOCCERDiv && suspendedMSOCCERDiv.classList.add('hidden');
                                        }
                                        if (suspendedSOCCERDiv) {
                                            suspendedSOCCERDiv && suspendedSOCCERDiv.classList.add('hidden');
                                        }
                                    }
                                    const boxes = document.querySelectorAll('.market_runners_' + runner.market_id.replace('.', '') + '_' + runner.selection_id);
                                    for (const box of boxes) {
                                        box.classList.add('disabled');
                                    }
                                }
                                else {
                                    const boxes = document.querySelectorAll('.market_runners_' + runner.market_id.toString().replace('.', '') + '_' + runner.selection_id);
                                    for (const box of boxes) {
                                        box.classList.remove('disabled');
                                    }
                                }

                                var match_odd_row = document.getElementsByClassName('table_row_' + runner.market_id.toString().replace('.', '') + '_' + runner.selection_id)[0];


                                if (runner.status == 'SUSPENDED' || runner.status == 'CLOSE' || runner.status == 'CLOSED') {


                                    if (document.getElementById('availableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                        if (match_odd_row) {

                                            match_odd_row.setAttribute('data-title', runner.status);
                                            // match_odd_row.parentElement.classList.add("suspended");
                                        }
                                        if (parseFloat(document.getElementById('availableToBack1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_1_price)) {
                                        } else {
                                        }
                                        if (parseFloat(document.getElementById('availableToLay1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_1_price)) {
                                        } else {
                                        }
                                    }
                                    // mobile{
                                    if (document.getElementById('MavailableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                        if (match_odd_row) {

                                            match_odd_row.setAttribute('data-title', runner.status);
                                            // match_odd_row.parentElement.classList.add("suspended");
                                        }
                                        if (parseFloat(document.getElementById('MavailableToBack1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_1_price)) {
                                        } else {
                                        }
                                        if (parseFloat(document.getElementById('MavailableToLay1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_1_price)) {
                                        } else {
                                        }
                                    }
                                    // }
                                    if (document.getElementById('availableToLay2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                        if (match_odd_row) {

                                            match_odd_row.setAttribute('data-title', runner.status);
                                            // match_odd_row.parentElement.classList.add("suspended");
                                        }
                                        if (parseFloat(document.getElementById('availableToBack2_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_2_price)) {
                                        } else {
                                        }
                                        if (parseFloat(document.getElementById('availableToLay2_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_2_price)) {
                                        } else {
                                        }
                                    }
                                    if (document.getElementById('availableToLay3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                        if (match_odd_row) {

                                            match_odd_row.setAttribute('data-title', runner.status);
                                            // match_odd_row.parentElement.classList.add("suspended");
                                        }
                                        if (parseFloat(document.getElementById('availableToBack3_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_3_price)) {
                                        } else {
                                        }
                                        if (parseFloat(document.getElementById('availableToLay3_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_3_price)) {
                                        } else {
                                        }
                                    }
                                } else {
                                    if (document.getElementById('availableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                        if (match_odd_row) {
                                            match_odd_row.parentElement.setAttribute('data-title', "");
                                            match_odd_row.parentElement.classList.remove("suspended");
                                        }
                                        if (parseFloat(document.getElementById('availableToBack1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_1_price)) {
                                            document.getElementById('availableToBack1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_1_price);
                                        } else {
                                            document.getElementById('availableToBack1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_1_price);
                                        }
                                        if (parseFloat(document.getElementById('availableToLay1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_1_price)) {
                                            document.getElementById('availableToLay1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_1_price);
                                        } else {
                                            document.getElementById('availableToLay1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_1_price);
                                        }
                                    }
                                    // mobile{
                                    if (document.getElementById('MavailableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                        if (match_odd_row) {
                                            match_odd_row.parentElement.setAttribute('data-title', "");
                                            match_odd_row.parentElement.classList.remove("suspended");
                                        }
                                        if (parseFloat(document.getElementById('MavailableToBack1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_1_price)) {
                                            document.getElementById('MavailableToBack1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_1_price);
                                        } else {
                                            document.getElementById('MavailableToBack1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_1_price);
                                        }
                                        if (parseFloat(document.getElementById('MavailableToLay1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_1_price)) {
                                            document.getElementById('MavailableToLay1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_1_price);
                                        } else {
                                            document.getElementById('MavailableToLay1_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_1_price);
                                        }
                                    }
                                    // }
                                    if (document.getElementById('availableToLay2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                        if (match_odd_row) {
                                            match_odd_row.parentElement.setAttribute('data-title', "");
                                            match_odd_row.parentElement.classList.remove("suspended");
                                        }
                                        if (parseFloat(document.getElementById('availableToBack2_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_2_price)) {
                                            document.getElementById('availableToBack2_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_2_price);
                                        } else {
                                            document.getElementById('availableToBack2_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_2_price);
                                        }
                                        if (parseFloat(document.getElementById('availableToLay2_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_2_price)) {
                                            document.getElementById('availableToLay2_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_2_price);
                                        } else {
                                            document.getElementById('availableToLay2_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_2_price);
                                        }
                                    }
                                    if (document.getElementById('availableToLay3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                        if (match_odd_row) {
                                            match_odd_row.parentElement.setAttribute('data-title', "");
                                            match_odd_row.parentElement.classList.remove("suspended");
                                        }
                                        if (parseFloat(document.getElementById('availableToBack3_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_3_price)) {
                                            document.getElementById('availableToBack3_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_3_price);
                                        } else {
                                            document.getElementById('availableToBack3_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_3_price);
                                        }
                                        if (parseFloat(document.getElementById('availableToLay3_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_3_price)) {
                                            document.getElementById('availableToLay3_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_3_price);
                                        } else {
                                            document.getElementById('availableToLay3_price_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_3_price);
                                        }
                                    }


                                }
                                /************************Size */


                                if (document.getElementById('availableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                    document.getElementById('availableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                    document.getElementById('availableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                    if (parseFloat(document.getElementById('availableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_1_size)) {
                                        document.getElementById('availableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.add("spark");
                                        setTimeout(function () {
                                            if (document.getElementById('availableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id))
                                                document.getElementById('availableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                        },
                                            700);
                                        document.getElementById('availableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_1_size);
                                    } else {
                                        document.getElementById('availableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_1_size);
                                    }
                                    if (parseFloat(document.getElementById('availableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_1_size)) {
                                        document.getElementById('availableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.add("spark");
                                        document.getElementById('availableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_1_size);
                                        setTimeout(function () {
                                            if (document.getElementById('availableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id))
                                                document.getElementById('availableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                        }
                                            , 700);
                                    } else {
                                        document.getElementById('availableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_1_size);
                                    }
                                }
                                // mobile
                                if (document.getElementById('MavailableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                    document.getElementById('MavailableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                    document.getElementById('MavailableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                    if (parseFloat(document.getElementById('MavailableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_1_size)) {
                                        document.getElementById('MavailableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.add("spark");
                                        setTimeout(function () {
                                            if (document.getElementById('MavailableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id))
                                                document.getElementById('MavailableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                        },
                                            700);
                                        document.getElementById('MavailableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_1_size);
                                    } else {
                                        document.getElementById('MavailableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_1_size);
                                    }
                                    if (parseFloat(document.getElementById('MavailableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_1_size)) {
                                        document.getElementById('MavailableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.add("spark");
                                        document.getElementById('MavailableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_1_size);
                                        setTimeout(function () {
                                            if (document.getElementById('MavailableToBack1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id))
                                                document.getElementById('MavailableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                        }
                                            , 700);
                                    } else {
                                        document.getElementById('MavailableToLay1_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_1_size);
                                    }
                                }
                                // }
                                if (document.getElementById('availableToBack2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                    document.getElementById('availableToBack2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                    document.getElementById('availableToLay2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                    if (parseFloat(document.getElementById('availableToBack2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_2_size)) {
                                        document.getElementById('availableToBack2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.add("spark");
                                        setTimeout(function () {
                                            if (document.getElementById('availableToBack2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id))
                                                document.getElementById('availableToBack2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                        },
                                            700);
                                        document.getElementById('availableToBack2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_2_size);
                                    } else {
                                        document.getElementById('availableToBack2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_2_size);
                                    }
                                    if (parseFloat(document.getElementById('availableToLay2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_2_size)) {
                                        document.getElementById('availableToLay2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.add("spark");
                                        document.getElementById('availableToLay2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_2_size);
                                        setTimeout(function () {
                                            if (document.getElementById('availableToBack2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id))
                                                document.getElementById('availableToLay2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                        }
                                            , 700);
                                    } else {
                                        document.getElementById('availableToLay2_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_2_size);
                                    }
                                }
                                if (document.getElementById('availableToBack3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id)) {
                                    document.getElementById('availableToBack3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                    document.getElementById('availableToLay3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                    if (parseFloat(document.getElementById('availableToBack3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.back_3_size)) {
                                        document.getElementById('availableToBack3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.add("spark");
                                        setTimeout(function () {
                                            if (document.getElementById('availableToBack3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id))
                                                document.getElementById('availableToBack3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                        },
                                            700);
                                        document.getElementById('availableToBack3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_3_size);
                                    } else {
                                        document.getElementById('availableToBack3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.back_3_size);
                                    }
                                    if (parseFloat(document.getElementById('availableToLay3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML) != parseFloat(runner.lay_3_size)) {
                                        document.getElementById('availableToLay3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.add("spark");
                                        document.getElementById('availableToLay3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_3_size);
                                        setTimeout(function () {
                                            if (document.getElementById('availableToBack3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id))
                                                document.getElementById('availableToLay3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).parentElement.classList.remove("spark");
                                        }
                                            , 700);
                                    } else {
                                        document.getElementById('availableToLay3_size_' + runner.market_id.replace('.', '') + '_' + runner.selection_id).innerHTML = parseFloat(runner.lay_3_size);
                                    }
                                }
                            });
                        });
                    }
                }
            }
            if (data.action == "FANCY_UPDATE") {
                let market = data.data;
                if (market) {
                    if (market?.fancy_data && market?.fancy_data.length) {
                        fancyHtml(market?.fancy_data)
                    }
                }
            }
            if (data.action == "USER_EVENT_ACTION") {
                let marketData = data.data;
                console.log('marketData', marketData);
                if (marketData) {
                    if (marketData.type == "event_market") {
                        if (event_id && isAuthenticated) {

                            dispatch(fetchEventDetails(event_id));
                            dispatch(fetchOpenBetById(event_id));
                            dispatch(fetchFancy(event_id));
                        }
                        else if (event_id && !isAuthenticated) {
                            dispatch(fetchEventDetailsBeforeLogin(event_id));
                            dispatch(fetchFancy(event_id));
                        }
                        dispatch(fetchBlockedMarketTypesAsync(event_id));

                        if (marketData.market_name == "Fancy") {
                            dispatch(getMatchFancyData({
                                event_id: event_id,
                                user_id: profileData ? profileData._id : ''
                            }))
                        }

                        if (profileData) {
                            dispatch(fetchSportsEvents({
                                user_id: profileData._id,
                                event_id: event_id,
                            }))
                        }

                    }

                    // if (marketData.type == "user_general_setting" || marketData.type == "event_general_setting") {
                    //     getGeneralSetting();
                    // }

                }
            }
        }

        WebSocketEventEmitter.on("message", handleMessage);

        return () => {
            WebSocketEventEmitter.off("message", handleMessage); // Cleanup on unmount
        };

    }, [event_id, marketTypes]);


    function SetPosition(stake, priceVal, market_id, is_back, selection_id) {
        priceVal = parseFloat(priceVal)
        var MarketId = market_id;
        var MId = MarketId.replace('.', '');
        var selectionId = selection_id;
        var isback = is_back;
        stake = parseFloat(stake);
        let MatchMarketTypes = "";
        var runners = document.getElementsByClassName("position_" + MId);
        var tempRunners = "";
        for (var item of runners) {
            var selecid = item.getAttribute('data-id');
            var winloss = parseFloat(item.value);
            var curr = 0;
            console.log('item:', item)
            if (selectionId == selecid) {
                if (isback) {
                    if (MatchMarketTypes == 'M') {
                        curr = winloss + ((priceVal * stake) / 100);
                    } else {
                        curr = winloss + ((priceVal * stake) - stake);
                    }
                } else {
                    if (MatchMarketTypes == 'M') {
                        curr = winloss + (-1 * parseFloat((priceVal * stake) / 100));
                    } else {
                        curr = winloss + (-1 * parseFloat((priceVal * stake) - stake));
                    }
                }
            } else {
                if (isback == 1) {
                    curr = winloss + (-1 * (stake));
                } else {
                    curr = winloss + stake;
                }
            }
            var currV = curr;
            if (document.getElementById(selecid + "_maxprofit_loss_runner_prev_" + MId)) {
                document.getElementById(selecid + "_maxprofit_loss_runner_prev_" + MId).setAttribute('data-value', winloss.toFixed(2))
                document.getElementById(selecid + "_maxprofit_loss_runner_prev_" + MId).innerHTML = Math.abs(winloss.toFixed(2));
            }
            if (document.getElementById(selecid + "_maxprofit_list_loss_runner_next_" + MId)) {
                document.getElementById(selecid + "_maxprofit_list_loss_runner_next_" + MId).setAttribute('data-value', currV.toFixed(2))
                document.getElementById(selecid + "_maxprofit_list_loss_runner_next_" + MId).innerHTML = Math.abs(currV.toFixed(2));
            }
            if (document.getElementById(selecid + "_maxprofit_Mlist_loss_runner_next_" + MId)) {
                document.getElementById(selecid + "_maxprofit_Mlist_loss_runner_next_" + MId).setAttribute('data-value', currV.toFixed(2))
                document.getElementById(selecid + "_maxprofit_Mlist_loss_runner_next_" + MId).innerHTML = Math.abs(currV.toFixed(2));
            }
        }
    }
    const placeStakeValue = (stake) => {
        if (String(stake).startsWith("NaN")) {
            stake = String(stake).replace("NaN", "");
        }
        setStakeValue(parseFloat(stake));
        calc(stake, BetPlaceData.price, BetPlaceData.selection_id)
        SetPosition(stake, BetPlaceData.price, BetPlaceData.market_id, BetPlaceData.is_back, BetPlaceData.selection_id);
    };
    const handlePriceValue = (priceVal) => {
        if (String(priceVal).startsWith("NaN")) {
            priceVal = String(priceVal).replace("NaN", "");
        }
        priceVal = parseFloat(priceVal).toFixed(2);
        setBetPlaceData({
            ...BetPlaceData,
            price: parseFloat(priceVal).toFixed(2)
        });
        calc(StakeValue, priceVal, BetPlaceData.selection_id)
        SetPosition(StakeValue, priceVal, BetPlaceData.market_id, BetPlaceData.is_back, BetPlaceData.selection_id);
    };
    function calc(t_stake, priceVal, selection_id) {
        var isfancy = BetPlaceData.is_fancy;
        priceVal = parseFloat(priceVal);
        t_stake = parseFloat(t_stake);
        var isback = BetPlaceData.is_back
        if (!isfancy) {
            var pl = ((priceVal * t_stake) - t_stake);

            pl = parseFloat(pl.toFixed(2));
            if (isback) {
                setProfitValue(pl)
                setLossValue(t_stake)
            } else {
                setLossValue(pl)
                setProfitValue(t_stake)
            }
            // SetPosition(priceVal);
        } else {
            if (document.getElementById('fancy_lay_size_' + selection_id)) {
                var NoValume = parseInt(document.getElementById('fancy_lay_size_' + selection_id).innerHTML);
                var YesValume = parseInt(document.getElementById('fancy_back_size_' + selection_id).innerHTML);
                var inputno = parseFloat(document.getElementById(`fancy_lay_price_${selection_id}`).innerHTML);
                var inputyes = parseFloat(document.getElementById(`fancy_back_price_${selection_id}`).innerHTML);
            }


            pl = parseFloat(t_stake);

            if (inputno == inputyes) {
                if (isback) {
                    setLossValue(pl.toFixed(2))
                    setProfitValue((YesValume * pl / 100).toFixed(2))

                } else {
                    setLossValue((NoValume * pl / 100).toFixed(2))
                    setProfitValue(pl.toFixed(2))

                }
            } else {
                setLossValue(pl.toFixed(2))
                setProfitValue(pl.toFixed(2))
            }

        }
    }
    const handleOpenBetSlip = (
        event_id,
        market_id,
        is_back,
        size,
        is_fancy,
        selection_id,
        runner_name,
        htmlId,
        PM_FANCY = null,
        market_name,
        is_manual = 'No'
    ) => {
        if (userdata?.user_type == 'User') {
            setShowBetsSlip(true);
            setSelection_id(selection_id)
            setMarketId(market_id)
            setType(is_back ? 'back' : 'lay')
            setHtmlId(htmlId)
            setSize(size)
            setIs_fancy(is_fancy)

            // console.log('is_manual',is_manual);
            if (selection_id) {
                setSelectionIdNew(selection_id)
            }
            // console.log({
            //     'event_id': event_id,
            //     'market_id': market_id,
            //     'is_back': is_back,
            //     'size': document.getElementById(size)?.innerHTML,
            //     'is_fancy': is_fancy,
            //     'selection_id': selection_id,
            //     'runner_name': runner_name,
            //     'new_price': document.getElementById(htmlId)?.innerHTML,
            //     'PM_FANCY': PM_FANCY,
            //     'market_name': market_name,
            // })

            // console.log('yes ')

            let selectElements = document.getElementsByClassName('market_runners_' + market_id.replace('.', '') + '_' + selection_id);
            // if (selectElements.length > 0) {
            //     let check_class_exists = document.getElementsByClassName('market_runners_' + market_id.replace('.', '') + '_' + selection_id)[0].classList.contains('disabled');
            //     if (check_class_exists) {
            //         return false;
            //     }

            // }


            setProfitValue(0);
            setStakeValue(0)
            var priceNew = document.getElementById(htmlId).innerHTML;
            var lastFive = market_id.substr(market_id.length - 3);
            if (lastFive == "-BM") {
                priceNew = ((priceNew / 100) + 1).toFixed(2);
            }
            else {
                if (market_name == "Bookmaker" || is_manual == "Yes") {
                    priceNew = ((priceNew / 100) + 1).toFixed(2);
                }
            }
            // console.log('priceNew:', priceNew)
            setBetPlaceData({
                event_id: event_id,
                market_id: market_id,
                is_back: is_back ? 1 : 0,
                price: priceNew,
                is_fancy: is_fancy,
                selection_id: selection_id,
                runner_name: runner_name,
                PM_FANCY: PM_FANCY
            });
            setTimeout(function () {
                SetPosition(0, priceNew, market_id, is_back, selection_id)
                calc(0, priceNew, selection_id)
                placeStakeValue(defaultStake);
            }, 800);
        }
    }
    function calc(t_stake, priceVal, selection_id) {
        var isfancy = BetPlaceData.is_fancy;
        priceVal = parseFloat(priceVal);
        t_stake = parseFloat(t_stake);
        var isback = BetPlaceData.is_back
        if (!isfancy) {
            var pl = ((priceVal * t_stake) - t_stake);

            pl = parseFloat(pl.toFixed(2));
            if (isback) {
                setProfitValue(pl)
                setLossValue(t_stake)
            } else {
                setLossValue(pl)
                setProfitValue(t_stake)
            }
            // SetPosition(priceVal);
        } else {
            if (document.getElementById('fancy_lay_size_' + selection_id)) {
                var NoValume = parseInt(document.getElementById('fancy_lay_size_' + selection_id).innerHTML);
                var YesValume = parseInt(document.getElementById('fancy_back_size_' + selection_id).innerHTML);
                var inputno = parseFloat(document.getElementById(`fancy_lay_price_${selection_id}`).innerHTML);
                var inputyes = parseFloat(document.getElementById(`fancy_back_price_${selection_id}`).innerHTML);
            }


            pl = parseFloat(t_stake);

            if (inputno == inputyes) {
                if (isback) {
                    setLossValue(pl.toFixed(2))
                    setProfitValue((YesValume * pl / 100).toFixed(2))

                } else {
                    setLossValue((NoValume * pl / 100).toFixed(2))
                    setProfitValue(pl.toFixed(2))

                }
            } else {
                setLossValue(pl.toFixed(2))
                setProfitValue(pl.toFixed(2))
            }

        }
    }
    async function betPlace(ishow) {

        if (profileData && userdata) {

            let exposureLimit;
            if (profileData.user_type == "User") {
                if (userBalance?.balance >= (BetPlaceData.is_fancy ? StakeValue : lossValue)) {
                    if (profileData?.exposer_limit) {
                        exposureLimit = Number(profileData?.exposer_limit);
                        if (exposureLimit < lossValue) {
                            NotificationManager.error(`Exposure Limit Is ${exposureLimit}`, '', 3000);
                            return;
                        }

                    }
                    setLoadingForBetPlace(true)

                    var data = JSON.stringify({
                        user_id: profileData._id,
                        match_id: BetPlaceData.event_id || event_id,
                        selection_id: BetPlaceData.selection_id,
                        is_back: BetPlaceData.is_back,
                        stake: StakeValue,
                        price_val: BetPlaceData.price,
                        market_id: BetPlaceData.market_id,
                        is_fancy: BetPlaceData.is_fancy == 1 ? "Yes" : "No",
                        market_name: "Match odds",
                        profit: ProfitValue,
                        loss: lossValue,
                        pm_fancy: BetPlaceData.PM_FANCY
                    });

                    var config = {
                        method: "post",
                        url: `${Appconfig.apiUrl}api/betting/create`,
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        },
                        data: data,
                    };
                    // alert("success");
                    axios(config)
                        .then(async function (response) {
                            // dispatch(setData(new Date().toISOString()));
                            try {
                                setSelection_id('')
                                setHtmlId('')
                                setProfitValue(0);
                                setStakeValue(0);
                                setShowBetsSlip(false)


                                var data;
                                if (profileData) {
                                    data = {
                                        user_id: profileData._id,
                                        event_id: event_id,
                                    };
                                }
                                dispatch(getFancyExposure(event_id));
                                if (socketStatus) {
                                    sendMessage({
                                        action: "USER_BET_PLACE",
                                        data: {
                                            user_id: profileData?._id,
                                            masters: profileData?.masters
                                        }
                                    });
                                }

                                if (response.data.result == 0) {
                                    NotificationManager.error(response.data.resultMessage, '', 3000);
                                    setLoadingForBetPlace(false)
                                } else {
                                    NotificationManager.success(response.data.message, '', 3000);
                                    dispatch(getUserBalanceAsync());
                                    const profileResponse = await fetchUserProfile();
                                    dispatch(setProfileData(profileResponse?.data?.data)); // Set the fetched profile data
                                    dispatch(fetchOpenBetById(event_id));
                                    dispatch(fetchEventDetails(event_id));
                                    if (response.data.resultData[0].is_back == 1) {
                                    }
                                    if (response.data.resultData[0].is_back == 0) {
                                    }
                                    setLoadingForBetPlace(false)
                                }
                                var MId = BetPlaceData.market_id.replace('.', '');
                                var selectionId = BetPlaceData.selection_id;
                                var runners = document.getElementsByClassName("position_" + MId);
                                for (var item of runners) {
                                    var selecid = item.getAttribute('data-id');
                                    document.getElementById(selecid + "_maxprofit_list_loss_runner_next_" + MId).innerHTML = ''
                                    document.getElementById(selecid + "_maxprofit_Mlist_loss_runner_next_" + MId).innerHTML = ''
                                }
                                setBetPlaceData({
                                    event_id: "",
                                    market_id: "",
                                    is_back: "",
                                    price: "",
                                    is_fancy: "",
                                    selection_id: "",
                                    runner_name: "",
                                });
                                setLoadingForBetPlace(false)



                            } catch (e) {
                                setLoadingForBetPlace(false)
                                console.log(e.message)
                            }
                            finally {
                                setLoadingForBetPlace(false)
                            }
                        })
                        .catch((error) => {
                            setLoadingForBetPlace(false)
                            console.log('Error in bet placement:', error);
                            NotificationManager.error(error?.response?.data?.message, '', 3000);
                        });

                } else {
                    setLoadingForBetPlace(false)
                    NotificationManager.error("Insufficient Balance", '', 3000);
                }
            }
            else {
                setLoadingForBetPlace(false)
                NotificationManager.error(`${profileData?.user_type} is not allowed to place bet`, '', 3000);
            }
        }
        else {
            setLoadingForBetPlace(false)
            navigate('/login')
        }
    }

    const findFancyExposure = (selectionId) => {

        let findItem = fancyExposure.find((item) => item.selection_id == selectionId);

        if (findItem) {
            return findItem?.min
        }
        else {
            return false;
        }
    }
    const checkFancyExposureExists = (selectionId) => {
        let findItem = fancyExposure.find((item) => item.selection_id == selectionId);

        if (findItem) {
            return true
        }
        else {
            return false;
        }
    }

    useEffect(() => {
        if (event_id && isAuthenticated) {
            dispatch(getFancyExposure(event_id));
        }
    }, [event_id, dispatch, isAuthenticated])
    // const marketPriorityOrder = ['Match Odds', 'Bookmaker', 'Toss', 'TIED_MATCH'];
    const marketPriorityOrder = ['Match Odds', 'Bookmaker'];
    const specificMarketTypes = ['Toss', 'TIED_MATCH'];



    useEffect(() => {
        const sortedMarketTypes = eventData?.marketTypes ? [...eventData.marketTypes]
            .sort((a, b) => {
                // Get the indices of markets in the priority lists
                const priorityA = marketPriorityOrder.indexOf(a.market_name);
                const priorityB = marketPriorityOrder.indexOf(b.market_name);
                const specificA = specificMarketTypes.indexOf(a.market_name);
                const specificB = specificMarketTypes.indexOf(b.market_name);

                // First, handle markets in the main priority order
                if (priorityA !== -1 && priorityB !== -1) {
                    return priorityA - priorityB;
                }
                if (priorityA !== -1) return -1;
                if (priorityB !== -1) return 1;

                // Then, handle specific market types
                if (specificA !== -1 && specificB !== -1) {
                    return specificA - specificB;
                }
                if (specificA !== -1) return 1;
                if (specificB !== -1) return -1;

                // Handle manual markets
                const isManualA = a.is_manual === 'Yes';
                const isManualB = b.is_manual === 'Yes';

                // Place manual markets between Bookmaker and Toss
                if (isManualA && !isManualB) return 1;
                if (!isManualA && isManualB) return -1;

                // If neither market is special, maintain original order
                return 0;
            }) : [];
        if (eventData) {
            dispatch(setSortedEvents(sortedMarketTypes));
        }
    }, [eventData]);

    function getFancyPosition(selectionId) {
        if (userdata) {
            var data = JSON.stringify({
                user_id: profileData._id,
                event_id: event_id,
                fancy_id: selectionId
            });
            var config = {
                method: "post",
                url: `https://digital.allcasino.in:3000/betting/getFancyPosition`,
                headers: {
                    "Content-Type": "application/json",
                },
                data: data,
            };
            axios(config)
                .then(function (response) {
                    try {
                        setPostionFancyList(response.data.resultData);
                        setBookModalOpen(true)
                    } catch (e) {
                        console.log(e)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
        else {
            navigate('/')
        }
    }

    useEffect(() => {
        if (event_id && isAuthenticated) {
            dispatch(fetchBlockedMarketTypesAsync(event_id));
        }
    }, [event_id, dispatch, isAuthenticated]);

    const blockUnblockMarket = (event_id, market_id, market_name, main_market = null) => {

        let check_market_name = market_id.split('_')[1];
        let update_market_name;

        if (check_market_name == "FANCY") {
            update_market_name = "Fancy";
        } else {
            update_market_name = main_market;
        }

        var data = JSON.stringify({
            "user_id": profileData?._id,
            "event_id": event_id,
            "market_id": market_id,
            "fancy_id": "0",
            "event_type_id": event_type_id,
            "type": "Market",
            "market_name": update_market_name,
            "oddsType": main_market == "Match Odds" || main_market == "Bookmaker" || main_market == "TIED_MATCH" || main_market == "Toss" ? market_name : "Market"
        });
        if (isAuthenticated) {
            dispatch(blockUnblockMarketTypeAsync(data))
                .unwrap()
                .then((response) => {
                    NotificationManager.success(response.message, '', 1000);
                    dispatch(fetchBlockedMarketTypesAsync(event_id));
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    console.log('chips', chips)
    return (
        <>
            {loadingForBetPlace && <Loader />}
            <Modal title={'Book'} className='book-model relative top-1 lg:top-7 lg:!w-[352px]' onCancel={() => setBookModalOpen(false)} footer={null} open={bookModalOpen} >
                <div className='p-[5px] text-[#23282c]'>
                    <div className='grid grid-cols-12 border-[2px] border-t-[1px] border-[#333]'>
                        <div className='col-span-12 bg-[#e0e6e6]'>
                            <div className='grid grid-cols-12'>
                                <div className='col-span-6 flex items-center justify-center border-t-[1px] border-r-[1px] border-[#000000] '>
                                    <span className='text-[#000000] font-bold'> Run</span>
                                </div>
                                <div className='col-span-6 flex items-center justify-center border-t-[1px] border-[#000000]'>
                                    <span className='text-[#000000] font-bold'> Amount</span>
                                </div>
                            </div>
                        </div>

                        {postionFancyList.length > 0 ?
                            postionFancyList.map((item, index) => {
                                if (item < 0)
                                    return <>
                                        <div className='col-span-12 font-bold text-center'>
                                            <div className='grid grid-cols-12'>
                                                <div className='col-span-6 flex items-center justify-center border-t-[1px] border-r-[1px] border-[#000000] '>
                                                    <span className='text-[#000000] font-bold'> {index}</span>
                                                </div>
                                                <div className='col-span-6 flex items-center justify-center border-t-[1px] border-[#000000]'>
                                                    <span className='font-bold text-[red]' data-value={item}>{item}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                if (item >= 0 && item != null)
                                    return <>
                                        <div className='col-span-12 font-bold text-center'>
                                            <div className='grid grid-cols-12'>
                                                <div className='col-span-6 flex items-center justify-center border-t-[1px] border-r-[1px] border-[#000000] '>
                                                    <span className='text-[#000000] font-bold'> {index}</span>
                                                </div>
                                                <div className='col-span-6 flex items-center justify-center border-t-[1px] border-[#000000]'>
                                                    <span className='font-bold text-[green]' data-value={item}>{item}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                            })
                            :
                            <div className='col-span-12 font-bold text-center border-t-[1px] border-[#000000]'>No data!</div>
                        }

                    </div>
                </div>
            </Modal>
            <div className='relative w-full'>
                <div className="bg-[#fff] h-auto relative">
                    <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>
                        <span className="max-w-[220px] lg:max-w-[465px] float-left m-0 overflow-hidden pt-0 relative overflow-ellipsis whitespace-nowrap">{eventData?.event_name}</span>
                        <span className="max-w-[220px] lg:max-w-[465px] float-right  overflow-hidden pt-0 relative overflow-ellipsis whitespace-nowrap">{eventData?.open_date && new Date(eventData?.open_date).toLocaleString()}</span>
                    </p>
                </div>
                <div className='lg:hidden  text-[#ffffff] '>
                    <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] flex items-center justify-between capitalize'>
                        Live TV
                        <Switch className='tv-switch' size="small" value={showTv} onChange={handleSwitchChange} />
                    </p>
                </div>
                {
                    showTv && (
                        <div className='lg:hidden tviframe mb-[.25rem]'>
                            <iframe
                                className='h-[207px]'
                                title="iframe mobile"
                                id="tvframe"
                                marginwidth="0" marginheight="0" frameborder="0" width="100%" height="100%" scrolling="no" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"
                                onLoad={() => setShowTv(true)} src={eventData?.tv_link}
                            >
                            </iframe>
                        </div>
                    )
                }
                <div className="flex lg:hidden items-start bg-[#343a40] border-[#18adc580] border-b-[1px] gap-[2px] justify-around p-0 w-full matched_bet_box">
                    <div className={`match_info_name  ${activeTab == 'Market' && 'active'} `} onClick={() => setActiveTab('Market')}>
                        <span className="market-2">{activeTab}</span>
                        <div className="market market-1"></div>
                    </div>
                    <div className={`match_info_name ${activeTab == 'Open Bets' && 'active'}`} onClick={() => setActiveTab('Open Bets')}>
                        <span className="market-2">
                            {activeTab}
                            <span className="betcount">({openBets?.length})</span>
                        </span>
                        <div className="market market-1"></div>
                    </div>
                </div>
                {
                    activeTab == 'Open Bets' && (
                        <div className="lg:hidden bg-[#fff] w-full">
                            <table className="w-full whitespace-nowrap  text-[#212529]">
                                <thead className=''>
                                    <tr className="!bg-[#028dad] !text-[#ffffff]">
                                        <th className='px-[3px] py-px border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Matched Bet</th>
                                        <th className='px-[3px] py-px border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Odds</th>
                                        <th className='px-[3px] py-px border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Stake</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        openBets?.length > 0 ?
                                            openBets?.map((item, index) => (
                                                <tr key={index} className={item?.is_back ? "bg-[#72bbef]" : "bg-[#faa9ba]"}>
                                                    <th className='px-[3px] py-px border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>{item?.runner_name}</th>
                                                    <th className='px-[3px] py-px border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>{item?.price_val}</th>
                                                    <th className='px-[3px] py-px border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>{item?.stake}</th>
                                                </tr>
                                            ))
                                            :
                                            <tr>
                                                <td className="px-[3px] py-px border-[1px] border-[solid] border-[#dee2e6]  !text-[#c7313f] !text-center" colSpan="3">No bets found...</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    )
                }
                {/* {
                    eventData?.marketTypes?.map((market, i) =>
                        market?.marketRunners && market?.marketRunners.length > 0 && market?.market_name == "Match Odds" ?
                            market?.marketRunners.map((runner, i) => (
                                <EventTable
                                    key={i}
                                    eventData={eventData}
                                    market={market}
                                    marketId={marketId}
                                    selection_id={selection_id}
                                    setSelection_id={setSelection_id}
                                    setHtmlId={setHtmlId}
                                    type={type}
                                    handlePriceValue={handlePriceValue}
                                    BetPlaceData={BetPlaceData}
                                    placeStakeValue={placeStakeValue}
                                    StakeValue={StakeValue}
                                    setShowBetsSlip={setShowBetsSlip}
                                    showBetsSlip={showBetsSlip}
                                    handleOpenBetSlip={handleOpenBetSlip}
                                    setSize={setSize}
                                    betPlace={betPlace}
                                    is_fancy={is_fancy}
                                    checkHighestMarketPrice={checkHighestMarketPrice}
                                />
                            ))
                            : null
                    )
                } */}
                {
                    sortedMarketTypes.map((market, i) => (
                        <EventTable
                            key={i}
                            eventData={eventData}
                            market={market}
                            marketId={marketId}
                            selection_id={selection_id}
                            setSelection_id={setSelection_id}
                            setHtmlId={setHtmlId}
                            type={type}
                            handlePriceValue={handlePriceValue}
                            BetPlaceData={BetPlaceData}
                            placeStakeValue={placeStakeValue}
                            StakeValue={StakeValue}
                            setShowBetsSlip={setShowBetsSlip}
                            showBetsSlip={showBetsSlip}
                            handleOpenBetSlip={handleOpenBetSlip}
                            setSize={setSize}
                            betPlace={betPlace}
                            is_fancy={is_fancy}
                            checkHighestMarketPrice={checkHighestMarketPrice}
                            loading={loadingForBetPlace}
                            marketTypes={marketTypes}
                            blockUnblockMarket={blockUnblockMarket}
                            event_type_id={event_type_id}
                            marketName={marketName}
                            setMarketName={setMarketName}
                            chips={chips}
                        />
                    ))
                }
                {
                    // eventData?.fancy?.length > 0 && (
                    fancy?.length > 0 && (
                        <div className="mt-[.7rem]">
                            <div className="fancybtn-new">
                                <a className="bg-[#26a6c3] text-[#fff] rounded-tl-[5px] rounded-tr-[5px] cursor-pointer text-[12px] px-[15px] py-[5px] text-center">
                                    <span className="font-bold">Fancy</span>
                                    <i className="fa fa-minus lg:hidden pl-4 " aria-hidden="true"></i>
                                </a>
                            </div>
                            <div className="bg-[#26a6c3] h-auto relative">
                                <ul className="bg-[#26a6c3] flex items-center px-[2px]">
                                    <li className="inline-block mr-[3px]">
                                        <a className="bg-[#045662] text-[#fff] rounded-[5px] inline-block text-[14px] px-[15px] py-[5px] relative active">All</a>
                                    </li>
                                    <li className="inline-block mr-[3px]">
                                        <a className="text-[#fff] rounded-[5px] inline-block text-[14px] px-[15px] py-[5px] relative">
                                            {/* <span className="fancynew-budge">2</span> */}
                                            OVERS
                                        </a>
                                    </li>
                                    <li>
                                        <a className="text-[#fff] rounded-[5px] inline-block text-[14px] px-[15px] py-[5px] relative">
                                            {/* <span className="fancynew-budge">1</span> */}
                                            SINGLE OVER
                                        </a>
                                    </li>
                                    <li>
                                        <a className="text-[#fff] rounded-[5px] inline-block text-[14px] px-[15px] py-[5px] relative">
                                            {/* <span className="fancynew-budge">10</span> */}
                                            BATSMAN
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className=" bg-[#fff] text-[#000]">
                                <table className=" w-full text-[#212529]">
                                    <tbody>
                                        <tr className="bet-all-new leading-[22px]">
                                            <td className="text-[#000] font-bold px-[1px] py-[2px] !pb-0 border-t-[1px] border-[#dee2e6]">&nbsp;</td>
                                            <td className="text-[#000] font-bold px-[1px] py-[2px] !pb-0 border-t-[1px] border-[#dee2e6] relative text-center w-[15.7%]">
                                                <div>
                                                    <div className="">
                                                        <a id="btnBack" className="text-[#000] rounded-[4px] cursor-pointer inline-block float-left text-[14px] !leading-[13px] px-[0] py-[5px] w-[49%]" side="Back">
                                                            <span>No</span>
                                                        </a>
                                                    </div>
                                                    <div>
                                                        <a id="btnLay" className="text-[#000] rounded-[4px] cursor-pointer inline-block float-left text-[14px] !leading-[13px] px-[0] py-[5px] w-[49%]" side="Lay">
                                                            <span>Yes</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="text-[#000] font-bold px-[1px] py-[2px] !pb-0 border-t-[1px] border-[#dee2e6] relative text-center w-[15.7%]"> &nbsp; </td>
                                        </tr>
                                        {
                                            // eventData?.fancy?.map((fancy, i) => (
                                            fancy?.map((fancy, i) => (
                                                <Fancy
                                                    key={i}
                                                    eventData={eventData}
                                                    fancy={fancy}
                                                    event_id={event_id}
                                                    marketId={marketId}
                                                    selection_id={selection_id}
                                                    setSelection_id={setSelection_id}
                                                    setHtmlId={setHtmlId}
                                                    type={type}
                                                    handlePriceValue={handlePriceValue}
                                                    BetPlaceData={BetPlaceData}
                                                    placeStakeValue={placeStakeValue}
                                                    StakeValue={StakeValue}
                                                    setShowBetsSlip={setShowBetsSlip}
                                                    showBetsSlip={showBetsSlip}
                                                    handleOpenBetSlip={handleOpenBetSlip}
                                                    setSize={setSize}
                                                    betPlace={betPlace}
                                                    is_fancy={is_fancy}
                                                    checkHighestMarketPrice={checkHighestMarketPrice}
                                                    loading={loadingForBetPlace}
                                                    fancyExposure={fancyExposure}
                                                    checkFancyExposureExists={checkFancyExposureExists}
                                                    findFancyExposure={findFancyExposure}
                                                    getFancyPosition={getFancyPosition}
                                                    chips={chips}
                                                />
                                            ))
                                        }

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )
                }


            </div>
        </>
    );
}

export default Event;